import React, { useRef } from 'react';
import { useOutsideClick } from '@chakra-ui/react';

import { POWERED_BY_GOOGLE_SRC } from 'lib/googleAutocomplete';

import {
  GoogleAutocompleteImage,
  GoogleAutocompleteResultsWrapper,
} from './styles';

export const GoogleAutocompleteWrapper = ({ children, hideResults }) => {
  const wrapperRef = useRef(null);

  useOutsideClick({
    ref: wrapperRef,
    handler: () => hideResults && hideResults(),
  });

  return (
    <GoogleAutocompleteResultsWrapper ref={wrapperRef}>
      {children}

      <GoogleAutocompleteImage
        alt="powered by google logo"
        className="styles__PoweredByGoogle"
        src={POWERED_BY_GOOGLE_SRC}
      />
      <div id="GooglePlacesServiceMap" style={{ display: 'none' }} />
    </GoogleAutocompleteResultsWrapper>
  );
};
